import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { OptionsType } from "types/UtilsTypes";

export type AdminClientsTab = "reliance" | "other";

export default function useGetInvestmentsAdminClients(
  tab: AdminClientsTab,
  enabled = true,
) {
  return useQuery({
    queryKey: ["investments/admin/clients", tab],
    queryFn: async () => {
      return axiosInstance
        .get("/investments/admin/clients", {
          params: { tab },
        })
        .then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: (data: OptionsType[]) => data,
    retry: false,
    enabled,
    staleTime: 1000 * 60,
  });
}
